export enum PaymentProvider {
    Stripe = 'stripe',
    AppStore = 'app_store',
}

export type UserSettings = {
    newEditorPopupSeen: boolean;
    creditMigrationSeen: boolean;
    onBoardingAnswers: { step: number; state: any };
    onboardingDialogSeen: boolean;
    onboardFinished: boolean;
    switchBackSurveySeen: boolean;
};
